import { useRef } from "react";
import { Check, Music } from "lucide-react";

// Sons doux générés dans le navigateur (Web Audio API) — aucune ressource à fournir.
const TONES = [
  { label: "Cloche", freq: 528, type: "sine" },
  { label: "Douceur", freq: 396, type: "sine" },
  { label: "Sérénité", freq: 639, type: "sine" },
  { label: "Carillon", freq: 741, type: "triangle" },
];

export default function SoundsPlayer({ onComplete }) {
  const ctxRef = useRef(null);
  const start = useRef(Date.now());

  const play = (t) => {
    try {
      if (!ctxRef.current) ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
      const ctx = ctxRef.current;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = t.type;
      osc.frequency.value = t.freq;
      gain.gain.setValueAtTime(0.0001, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.05);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 2.2);
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start();
      osc.stop(ctx.currentTime + 2.3);
    } catch { /* audio non supporté */ }
  };

  return (
    <div className="w-full max-w-xl mx-auto text-center" data-testid="sounds-player">
      <p className="font-patient text-2xl text-gray-700 font-black mb-2">Sons doux</p>
      <p className="font-patient text-xl text-gray-500 mb-8">Touchez un bouton pour écouter un son apaisant.</p>
      <div className="grid grid-cols-2 gap-4 mb-8">
        {TONES.map((t) => (
          <button key={t.label} onClick={() => play(t)} data-testid={`sound-${t.label}`}
            className="min-h-[6rem] rounded-3xl bg-white border-4 border-emerald-700/15 flex flex-col items-center justify-center gap-2 active:scale-[0.97] transition-transform">
            <Music className="w-9 h-9 text-emerald-600" />
            <span className="font-patient font-black text-xl text-gray-800">{t.label}</span>
          </button>
        ))}
      </div>
      <button onClick={() => onComplete({ score: 100, accuracy: 100, duration: Math.round((Date.now() - start.current) / 1000) })}
        data-testid="sounds-done"
        className="w-full h-16 rounded-2xl bg-amber-400 text-amber-950 font-patient font-black text-2xl inline-flex items-center justify-center gap-3 active:scale-[0.98] transition-transform">
        Terminé <Check className="w-7 h-7" />
      </button>
    </div>
  );
}
